import { render, staticRenderFns } from "./SnackbarComponent.vue?vue&type=template&id=a2b3b01c&scoped=true"
import script from "./SnackbarComponent.js?vue&type=script&lang=js&external"
export * from "./SnackbarComponent.js?vue&type=script&lang=js&external"
import style0 from "./SnackbarComponent.vue?vue&type=style&index=0&id=a2b3b01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b3b01c",
  null
  
)

export default component.exports